export const state = () => {
  return {
    accountUrl: '',
    blogName: ''
  }
}

export const mutations = {
  SET_ACCOUNT_URL (state, data) {
    state.accountUrl = data
  },
  SET_BLOG_NAME (state, data) {
    state.blogName = data
  }
}

export const getters = {}

export const actions = {}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}